import { render, staticRenderFns } from "./NewTicket.vue?vue&type=template&id=4d2b064e&"
import script from "./NewTicket.vue?vue&type=script&lang=js&"
export * from "./NewTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports